export default "__VITE_ASSET__DAnz7PbK__"